import { numberEqualsWithRelativeTolerance } from '../../../common/numberEqualsWithRelativeTolerance/numberEqualsWithRelativeTolerance';
import { FeeType, } from '../../../transfer-fee-comparison/domain/Quote';
import { isWiseAlias } from '../../aliasFilter';
import isCurrencyWithoutDecimals from './currenciesWithoutDecimals';
import extractQuote from './extractQuote';
import extractWiseQuote from './extractWiseQuote';
function extractHiddenFeeInSourceCurrency(targetCurrencyCode, sendAmount, receivedAmount, marketedFee, midmarketRate) {
    const noDecimalsCurrencyTolerance = isCurrencyWithoutDecimals(targetCurrencyCode) ? 0.5 : 0;
    const toleranceAmountInPercentage = 0.00001;
    const expectedReceivedAmount = floorToTwoDecimalNumbers(midmarketRate * (sendAmount - marketedFee) - noDecimalsCurrencyTolerance);
    const receivedTheExpectedAmount = numberEqualsWithRelativeTolerance(receivedAmount, expectedReceivedAmount, toleranceAmountInPercentage);
    const receivedHigherThanExpected = receivedAmount > expectedReceivedAmount;
    const hasHiddenFee = !receivedTheExpectedAmount && !receivedHigherThanExpected;
    const hiddenFeePaidOnTargetCurrency = hasHiddenFee ? expectedReceivedAmount - receivedAmount : 0;
    return parseFloat((hiddenFeePaidOnTargetCurrency / midmarketRate).toFixed(2));
}
function extractFees(marketedFee, hiddenFee, sourceCurrency) {
    const fees = [];
    if (marketedFee > 0) {
        fees.push({
            type: FeeType.MARKETED,
            amount: { value: marketedFee, currency: sourceCurrency },
        });
    }
    if (hiddenFee > 0) {
        fees.push({
            type: FeeType.HIDDEN,
            amount: { value: hiddenFee, currency: sourceCurrency },
        });
    }
    return fees;
}
function transformQuotesResponseV2(quotesResults, quoteApi) {
    var _a;
    const wiseQuote = (_a = quotesResults.providers.find((provider) => isWiseAlias(provider.alias))) === null || _a === void 0 ? void 0 : _a.quotes[0].rate;
    const quotes = quotesResults.providers.map((p) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const quote = quoteApi && isWiseAlias(p.alias)
            ? extractWiseQuote(quoteApi)
            : extractQuote(p.quotes, quotesResults.targetCurrency);
        // eslint-disable-next-line fp/no-mutation
        const midMarketRate = quoteApi ? quoteApi.rate : wiseQuote;
        return buildQuoteObject(quotesResults, p, quote, midMarketRate);
    });
    return {
        quotes,
    };
}
function buildQuoteObject(quotesResults, provider, quote, midMarketRate) {
    const hiddenFee = extractHiddenFeeInSourceCurrency(quotesResults.targetCurrency, quotesResults.sendAmount, quote.receivedAmount, quote.fee, midMarketRate);
    const feesBreakdown = extractFees(quote.fee, hiddenFee, quotesResults.sourceCurrency);
    return {
        provider: {
            alias: provider.alias,
            name: provider.name,
            logoUrl: provider.logos.normal.svgUrl,
            logoAltText: provider.logos.altText,
            partner: provider.partner,
        },
        route: {
            sourceCurrency: quotesResults.sourceCurrency,
            targetCurrency: quotesResults.targetCurrency,
        },
        rate: quote.rate,
        fees: {
            breakdown: feesBreakdown,
            total: { value: quote.fee + hiddenFee, currency: quotesResults.sourceCurrency },
        },
        receiveAmount: { value: quote.receivedAmount, currency: quotesResults.targetCurrency },
        sendAmount: { value: quotesResults.sendAmount, currency: quotesResults.sourceCurrency },
        deliveryEstimation: quote.deliveryEstimation,
    };
}
function floorToTwoDecimalNumbers(value) {
    return Math.floor(value * 100) / 100;
}
export default transformQuotesResponseV2;
